<template>
	<div class="animated fadeIn">
		<b-card>
			<b-card-header>
				<i class="icon-menu mr-1"></i>使用者列表
				<div class="card-header-actions">
					<b-link @click="openUploader()" v-if="!cannotEdit"><i class="fa fa-file-excel-o"></i> 上傳Excel</b-link>&nbsp;
					<b-link @click="openEditor()" v-if="!cannotEdit"><i class="fa fa-plus"></i> 新增</b-link>
				</div>
			</b-card-header>
		  <b-card-body>
			<v-server-table :columns="columns" :data="data" :options="options" :theme="theme" ref="dataTable" id="dataTable">
				<a slot="unit_id" slot-scope="props">{{props.row.unit_name ? props.row.unit_name : '未連結'}}</a>
				<a slot="user_id" slot-scope="props">{{props.row.Admin.firstname + ' ' + props.row.Admin.lastname}}</a>

				<div slot="child_row" slot-scope="props">
					<b-button variant="info" class="btn-pill" size="sm" v-if="!cannotEdit" @click="editRow(props.row.id, props.row)"><i class="fa fa-pencil"></i> 編輯</b-button> &nbsp;
					<b-button variant="danger" class="btn-pill" size="sm" v-if="!cannotEdit" @click="delRow(props.row.id, props.row.name)"><i class="fa fa-times"></i> 刪除</b-button> &nbsp;
					<b-button class="btn-pill hidden" size="sm" @click="testRow(props.row.id)"><i class="fa fa-wrench"></i>重新設定密碼</b-button>
				</div>
			</v-server-table>
		  </b-card-body>
		</b-card>

		<b-modal title="使用者Excel" class="modal-info" v-model="showUploaderModal" @ok="uploadExcel()" @cancel="cancelUpload()" ok-title="上傳" cancel-title="取消">
		  <h5 class="text-success"><i class="fa fa-file-excel-o"></i> 匯入範本<a :href="import_template_file">下載</a></h5>
          <b-form-file ref="enduserexcel" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" v-model="end_user_excel" :state="Boolean(end_user_excel)" placeholder="請選擇內含使用者資料的Excel"></b-form-file>
	    </b-modal>

	    <b-modal title="使用者匯入錯誤報告" class="modal-warning" v-model="showDownloadErrorReport" ok-title="關閉" :ok-only="error_report?true:false">
          <h3 class="text-danger">使用者匯入過程中發現錯誤，請<a :href="error_report">下載</a>報告修正後重新上傳</h3>
	    </b-modal>

		<b-modal title="刪除使用者" size="sm" v-model="delRowShowModal" @ok="submitDelRow(delRowId)" ok-title="確定" cancel-title="取消">
	      {{delRowMsg}}
	    </b-modal>

	    <b-modal title="編輯器" class="modal-info" v-model="showEditorModal" @ok="submitRecord()" ok-title="儲存" cancel-title="取消" :ok-disabled="$v.$invalid">
	        <b-form>
              <h1>使用者資料</h1>
              <p class="text-muted">綠框為必填</p>
              <b-input-group class="mb-3">
                <b-input-group-prepend>
                	<b-input-group-text><i class="fa fa-clone"></i></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input type="text" 
                              class="form-control" 
                              placeholder="名稱" 
                              v-model.lazy.trim="$v.record.name.$model"
                              v-focus
                              :state="chkState('name')"
                              aria-describedby="invalidNameFeedback"/>
                <b-form-invalid-feedback id="invalidNameFeedback">名稱必填</b-form-invalid-feedback>
              </b-input-group>

              <b-input-group class="mb-3">
                <b-input-group-prepend>
                	<b-input-group-text><i class="fa fa-at"></i></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input type="text" 
                              class="form-control" 
                              placeholder="Email" 
                              v-model.lazy.trim="$v.record.email.$model"
                              :state="chkState('email')"
                              aria-describedby="invalidEmailFeedback"/>
                <b-form-invalid-feedback id="invalidEmailFeedback">Email必填</b-form-invalid-feedback>
              </b-input-group>

              <b-input-group class="mb-3">
                <b-input-group-prepend>
                	<b-input-group-text><i class="fa fa-at"></i></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input type="text" 
                              class="form-control" 
                              placeholder="密碼" 
                              v-model.lazy.trim="$v.record.password.$model"
                              :state="chkState('password')"
                              aria-describedby="invalidPasswordFeedback"/>
                <b-form-invalid-feedback id="invalidPasswordFeedback">密碼必填</b-form-invalid-feedback>
              </b-input-group>

              <b-input-group class="mb-4">
                <b-input-group-prepend>
                	<b-input-group-text><i class="fa-bank fa"></i></b-input-group-text>
                </b-input-group-prepend>
                <b-form-select id="device-unit_id"
                			   class="form-control hidden w-12" 
                               placeholder="單位" 
                               v-model.lazy.trim="$v.record.unit_id.$model"
                               :state="chkState('unit_id')"
                               aria-describedby="invalidUNITIDFeedback"/>
                <b-form-invalid-feedback id="invalidUNITIDFeedback">請選擇單位</b-form-invalid-feedback>
              </b-input-group>
              
              <b-input-group class="mb-4">
                <b-input-group-prepend>
                	<b-input-group-text><i class="fa fa-phone-square"></i></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input type="text" 
                              class="form-control" 
                              placeholder="電話" 
                              v-model.lazy.trim="record.phone"/>
              </b-input-group>

              <b-input-group class="mb-4">
                <b-input-group-prepend>
                	<b-input-group-text><i class="fa fa-birthday-cake"></i></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input type="date" 
                              class="form-control" 
                              placeholder="生日" 
                              v-model.lazy.trim="record.birthday"/>
              </b-input-group>

              <b-input-group class="mb-4">
                <b-input-group-prepend>
                	<b-input-group-text><i class="fa fa-briefcase"></i></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input type="text" 
                              class="form-control" 
                              placeholder="ID" 
                              v-model.lazy.trim="record.id_number"/>
              </b-input-group>

              <b-input-group class="mb-4">
                <b-input-group-prepend>
                	<b-input-group-text><i class="fa fa-child"></i></b-input-group-text>
                </b-input-group-prepend>
                <v-select v-model="record.gender" :options="gender_options" placeholder="性別"></v-select>
              </b-input-group>
              
              <b-input-group class="mb-4" v-if="!hide_demo_option">
                <b-input-group-prepend>
                	<b-input-group-text><i class="fa fa-usd"></i></b-input-group-text>
                </b-input-group-prepend>
                <v-select v-model="record.demo" :options="demo_options" placeholder="DEMO用"></v-select>
                <span class="text-primary help-text">DEMO用帳號不會通過金流計費</span>
              </b-input-group>
              
	    	</b-form>
	    </b-modal>
	</div>
</template>

<script>
import Vue from 'vue'
import {ServerTable, Event} from 'vue-tables-2'
import { required, minLength, between, email, minValue, integer } from 'vuelidate/lib/validators'
import { setupCalendar, DatePicker } from 'v-calendar'
import vSelect from 'vue-select'
import config from '@/config/global'
import notifications from '@/config/notifications'
import jQuery from 'jquery'
import select2 from 'select2'
import _ from 'lodash'
import moment from 'moment-timezone'

import 'v-calendar/lib/v-calendar.min.css'

const encrypt    = config.encrypt;
const decrypt    = config.decrypt;
const admin_root = config.admin_root;

const clean_form = {
	name:      '',
	password:  '',
	email:     '',
	birthday:  '',
	unit_id:   '',
	unit_name: '',
	phone:     '',
	gender:    '',
	id_number: '',
    demo:      'NO'
};

let $dyn_ajax_selec2 = null;

Vue.use(ServerTable)

export default {
	name: 'user_list',
	notifications,
	components: {
		ServerTable,
		Event,
		vSelect,
		'v-date-picker': DatePicker
    },
	data(){
		let app = this;
		let cannotEdit = app.$state.$get('ccff') === 'N/A' ? false : true;

		// console.info('cannotEdit:', cannotEdit);

		return {
            demo_options: [
				{label:'YES', value:'YES'},
				{label:'NO', value:'NO'}
			],
            hide_demo_option: cannotEdit,
			gender_options: [
				{label:'男', value:'男'},
				{label:'女', value:'女'},
				{label:'未知', value:'未知'}
			],
			end_user_excel: null,
			selected_row: null,
			isFindingLoading: false,
			editRowId: null,
			cannotEdit,
			record: Object.assign({}, clean_form),
			showEditorModal: false,
			showUploaderModal: false,
			error_report: null,
			showDownloadErrorReport: false,
			import_template_file: `${config.admin_root}/template/import_user_template.xlsx`,
			delRowShowModal: false,
			delRowId: 0,
			delRowMsg: '',
			columns: ['name', 'email', 'unit_id', 'phone', 'birthday', 'user_id', 'created'],
			data: [],
			options: {
				debounce: 86400000, // 停止預設的即時搜尋
				headings: {
					name:  '名稱',
					email: 'Email',
					unit_id: '單位',
					phone: '電話',
					birthday: '生日',
					user_id: '建立人',
					created: '建立時間'
				},
				orderBy: {
					column: 'created',
					ascending: false
				},
				sortable: ['name', 'email', 'unit_id', 'phone', 'birthday', 'user_id', 'created'],
				filterable: ['name', 'email', 'unit_id', 'birthday', 'phone'],
				sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
				pagination: {
					chunk: 5,
					edge: false,
					nav: 'scroll'
				},
				perPage: 25,
				requestFunction(data) {
					let action = `${admin_root}/get_list/EndUser`;
					let params = {
					    keyset: 'mqtt'
					};

					let ccff = this.$state.$get('ccff');
					if(ccff){
						params['ccff'] = ccff;
					}

					for(let col in data){
						params[col] = data[col];
					}

					// console.info('action:', action);

					// console.info('DataTable.data:', params);

					return fetch(action, {
						method: 'POST',
						headers: {
						'Content-Type': 'application/json',
						'Authorization': 'Bearer ' + app.$state.$get('adminuser').token
						},
						body: JSON.stringify(params)
					}).then(res => res.json()).then(result => {
						return {
						data: result.data || [],
						count: result.count || 0
						};
					}).catch(error => {
						return {
						data: [],
						count: 0
						};
					});
				}//eo requestFunction
			},
			useVuex: false,
	        theme: 'bootstrap4',
	        template: 'default'
		};//eo return
	},//eo data
	mounted(){
		// Search field 按下Enter後開始搜尋
		this.$nextTick(() => {
			let searchInput = document.querySelector('.VueTables__search-field input');
			if (searchInput) {
				// 取消 Vue Tables 內部的即時搜尋
				/*searchInput.addEventListener('input', (event) => {
					console.info('searchInput event:', event);
				}, true); // 捕獲模式，確保先執行*/

				// 監聽 Enter 鍵，才真正搜尋
				searchInput.addEventListener('keyup', (event) => {
					//console.info('keyup: ', event.key);
					//this.showSuccess({message:`key: ${event.key}`});
					if (event.key === "Enter" || event.key === "Go" || event.key === "Search") {
						this.$refs.dataTable.setFilter(searchInput.value);

						//強制清除 Vue Tables 內部的 debounce 計時器
						//this.$refs.dataTable.query = searchInput.value; // 直接覆寫內部值，避免 24 小時後觸發
					}
				});

				// 監聽 "失去焦點" (按 "下一步" 後，強制搜尋)
				searchInput.addEventListener('blur', () => {
					//console.info('blur event: 搜尋觸發');
					//this.showSuccess({message:'blur event: 搜尋觸發'});
					this.$refs.dataTable.setFilter(searchInput.value);
				});
			}
		});
	},
	methods: {

		editRow(row_id, row) {
			// console.info('edit row_id:', row_id);
			this.selected_row = row;
			this.openEditor(row_id);
			
			this.record = Object.assign({}, this.selected_row);
		},//eo editRow

		delRow(row_id, row_name) {
			// console.info('del row_id:', row_id);

			this.delRowShowModal = row_id ? true : false;
			this.delRowId        = row_id;
			this.delRowMsg       = `您確定要刪除${row_name}嗎？`;
		},//eo delRow

		submitDelRow(row_id) {
			let app    = this;
			let action = `${admin_root}/update_end_user`;
			let params = {
			    keyset: 'mqtt',
			    record: encodeURIComponent(encrypt(JSON.stringify({
			    	id: row_id,
			    	field: 'valid',
			    	value: 0,
			    	value_type: 'int'
			    })))
			};

			fetch(action, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'Authorization': 'Bearer ' + app.$state.$get('adminuser').token
				},
				body: JSON.stringify(params)
			}).then(res => res.json()).then(result => {
				if(result.success){
					app.showSuccess({
						title: '資料更新成功',
						message: result.message
					});

					app.$refs['dataTable'].refresh();
				} else {
					app.showError({
						title: '資料更新失敗',
						message: result.message
					});
				}
			}).catch(error => {
				app.showError({
					title: '資料更新失敗',
					message: result.message
				});
			});
		},

		testRow(row_id) {
			console.info('test row_id:', row_id);
			this.showWarn({
				message: '開發中',
				title: '功能暫停'
			});
		},//eo testRow

		chkState(val) {
	      const field = this.$v.record[val];
	      return !field.$dirty || !field.$invalid;
    	},

    	openEditor(row_id){
    		this.editRowId       = row_id;
    		this.showEditorModal = true;
    		this.$v.$reset();

    		let page_limit = 10;
    		let app        = this;

    		//workaround for select2 to be able to use search input
    		jQuery('div.modal-content').removeAttr('tabindex');

    		if(true){
				$dyn_ajax_selec2 = jQuery('#device-unit_id');

				// console.info('$dyn_ajax_selec2:', $dyn_ajax_selec2);

				if($dyn_ajax_selec2.length){
					//init select2
					$dyn_ajax_selec2.select2({
						width: 'copy',
				        dropdownAutoWidth: true,
						placeholder: '單位...',
						allowClear: true,
						ajax: { // instead of writing the function to execute the request we use Select2's convenient helper
				            url: `${admin_root}/get_unit_list`,
				            type: 'POST',
							dataType: 'json',
							quietMillis: 800 ,
							beforeSend: function (xhr) {
								xhr.setRequestHeader(
									"Authorization",
									"Bearer " + app.$state.$get('adminuser').token
								);
							},
				            data: function (params) {
				            	// console.info('term:', term, ', page:', page);
				                let preselected_id = jQuery(this).val();
				                return {
				                    preselected_id: preselected_id,
				                    query:          params.term, // search term
				                    page_limit:     page_limit,
				                    page:           params.page || 1
				                };
				            },
				            results: function (data, page) {
				                var more = (page * page_limit) < data.total;
				                return {results: data.results, more: more};
				            }
				        },//eo ajax
					}).on('change', (event) => {
						// console.info('data:', $dyn_ajax_selec2.select2('data')[0]);
						let selected_record = $dyn_ajax_selec2.select2('data')[0];
						
						if(selected_record){
							app.record.unit_name = selected_record.text;	
						} 

						app.record.unit_id   = $dyn_ajax_selec2.select2('val');
						
					});
				}
			}

			//workaround for Bootstrap4
			if($dyn_ajax_selec2.data('select2')){
				$dyn_ajax_selec2.data('select2').$container.addClass("form-control");
			}

			if(row_id && app.selected_row){
				let $option = jQuery('<option selected>讀取中...</option>').val(app.selected_row.end_user_id);
				// $dyn_ajax_selec2.val(app.selected_row.end_user_id).append($option).trigger('change');
				$dyn_ajax_selec2.val(app.selected_row.end_user_id).trigger('change');
				
				let action = `${admin_root}/get_unit_list`;
				fetch(action, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'Authorization': 'Bearer ' + app.$state.$get('adminuser').token
					},
					body: JSON.stringify({
						id: app.selected_row.unit_id
					})
				}).then(res => res.json()).then(result => {
					if(result.results.length){
						let user = result.results.pop();
						$option.text(user.text).val(user.id);
						$option.removeData();

						$dyn_ajax_selec2.append($option);

						$dyn_ajax_selec2.trigger({
						    type: 'select2:select',
						    params: {
						      data: user
						    }
						});

						$dyn_ajax_selec2.val(user.id).trigger('change');
					} else {
						$option.revmove();
						$dyn_ajax_selec2.val(null);
						app.showError({
							title: '系統錯誤',
							message: '無法讀取資料，請稍後再試'
						});
					}
				}).catch(error => {
					$option.revmove();
					$dyn_ajax_selec2.val(null);
					app.showError({
						title: '系統錯誤',
						message: '無法讀取資料，請稍後再試'
					});
				});
			} else {
				app.record       = Object.assign({}, clean_form);
				app.selected_row = null;
				app.row_id       = null;

				$dyn_ajax_selec2.val('').trigger('change');	
			}
    	},

    	submitRecord() {

    		let app    = this;
    		let row_id = app.editRowId;

    		this.$v.$touch();

		    if (this.$v.$invalid) {
		        this.showError({message:'請輸入必填欄位', title:'資料錯誤'});
		        this.showEditorModal = true;
		        return false;
		    }
            
            if(this.record.demo && this.record.demo.value !== undefined){
                this.record.demo = this.record.demo.value;
            }
            
            if(!this.record.birthday){
                this.record.birthday = moment().tz(config.timezone).format('YYYY-MM-DD');
            }

		    let to_save = this.record;

		    if(row_id){
		    	to_save['id'] = row_id;
		    }

		    if(_.isObject(to_save['gender'])){
		    	to_save['gender'] = to_save['gender']['value'];
			}

			console.info('before send: ', to_save);

		    to_save = encodeURIComponent(encrypt(JSON.stringify(to_save)));

		    let action = `${admin_root}/save_end_user`;
		    let params = {
		    	keyset: 'mqtt',
		    	record: to_save
		    };

			fetch(action, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'Authorization': 'Bearer ' + this.$state.$get('adminuser').token
				},
				body: JSON.stringify(params)
			}).then(res => res.json()).then(result => {
				if(result.success){
		    		app.showSuccess({
		    			title: '成功',
		    			message: '資料成功儲存'
		    		});
		    		app.$refs['dataTable'].refresh();
		    		app.record = Object.assign({}, clean_form);
		    		app.$v.$reset();
		    	} else {
		    		app.showError({
		    			title: '錯誤',
		    			message: '無法儲存資料，請稍後再試'
		    		});
		    		app.$refs['dataTable'].refresh();
		    	}
			}).catch(error => {
				app.showError({
                    title: '錯誤',
                    message: '無法儲存資料，請稍後再試'
                });
			});
    	},//eo submitRecords,
    	openUploader() {
    		let app                     = this;
    		app.showUploaderModal       = true;
    		app.error_report            = null;
    		app.showDownloadErrorReport = false;
    	},//eo openUploader
    	cancelUpload(){
    		let app = this;
    		app.showUploaderModal = false;
    		app.$refs.enduserexcel.reset();
    	},//eo cancelUpload
    	uploadExcel(event){
    		let app    = this;
    		let action = `${admin_root}/upload_end_user_excel`;

    		// console.info('file uploaded:', app.$refs.enduserexcel, ', form:', app.end_user_excel);
    		
    		//create form 
    		let form = new FormData();
    		form.append('end_user_excel', app.end_user_excel);
    		form.append('token', app.$state.$get('adminuser').token);
    		form.append('keyset', 'frontend');

    		let form_request = new XMLHttpRequest();
    		form_request.open('POST', action);
    		form_request.onload = (oEvent) => {
    			// console.info('form_request:', form_request);

    			if (form_request.status == 200) {
			      // app.showSuccess({message:'檔案上傳成功'});
			      try{
			      	let upload_result = JSON.parse(form_request.responseText);

			      	if(upload_result.success){
			      		app.showSuccess({message:'檔案上傳成功'});
			      	} else {
			      		app.showError({message:'無法上傳檔案#3. ' + (upload_result.message || '')});	
			      		console.info('File upload failed: ', upload_result.error || upload_result.message);
			      	}

			      	if(upload_result.error_report){
			      		app.error_report = `${config.admin_root}/${upload_result.error_report}`;
			      		app.showDownloadErrorReport = true;
			      	}

			      }catch(exp){
			      	app.showError({message:'無法上傳檔案#2'});
			      }
			    } else {
			      app.showError({message:'無法上傳檔案#1'});
			    }
    		};
    		form_request.send(form);
    		app.$refs.enduserexcel.reset();

    		return false;
    	},//eo uploadExcel
	},//eo methods
	validations: {
		record: {
			name: {
			  required,
			  minLength: minLength(2)
			},
			password: {
				required,
				minLength: minLength(4)	
			},
			email: {
			  required,
			  email
			},
			unit_id: {
			  required: false,
			  minLength: minLength(1)
			}
		}
	},//eo validations
	
};
</script>
<style lang="scss">
.card-body{padding:0;}
.add-btn{}
.help-text{margin-top: 0.5rem; margin-left: 0.8rem;}
.multiselect__input{width:100%;border:none;}

#dataTable {
	width: 95%;
	margin: 0 auto;
	margin-top: 0.5rem;
	font-size: 0.75rem;

	.VuePagination {
	  text-align: center;
	  justify-content: center;
	}

	.vue-title {
	  text-align: center ;
	  margin-bottom: 10px;
	}

	.VueTables__search-field {
	  display: flex;
	}
	.VueTables__search-field input {
	  margin-left: 0.25rem;
	}

	.VueTables__limit-field {
	  display: flex;
	}

	.VueTables__limit-field select {
	  margin-left: 0.25rem !important;
	}

	.VueTables__table th {
	  text-align: center;
	}

	.VueTables__child-row-toggler {
	  width: 16px;
	  height: 16px;
	  line-height: 16px;
	  display: block;
	  margin: auto;
	  text-align: center;
	}

	.VueTables__child-row-toggler--closed::before {
	  content: "+";
	}

	.VueTables__child-row-toggler--open::before {
	  content: "-";
	}

	.VueTables__sortable {
		padding: 0.25rem;
	}
}
</style>
